const AUDIT_LOG = [
  { timestamp: "14:22:10 12/Oct", initials: "JD", name: "John Doe",    action: "Modified Permissions",  entity: "Finance_Lead_Alpha",   status: "success" },
  { timestamp: "13:05:44 12/Oct", initials: "AM", name: "Alex Miller", action: "Archived Project",       entity: "South_Tower_Phase2",   status: "success" },
  { timestamp: "12:59:01 12/Oct", initials: "JD", name: "John Doe",    action: "System Config Update",   entity: "Global_Tax_Rules",     status: "success" },
  { timestamp: "11:15:20 12/Oct", initials: "SA", name: "System Auth", action: "Failed Login Attempt",   entity: "Admin_IP_34.12",       status: "blocked" },
  { timestamp: "10:42:15 12/Oct", initials: "SK", name: "Sarah King",  action: "Updated API Secret",     entity: "AWS_S3_Gateway",       status: "review"  },
];

const STATUS_CONFIG = {
  success: { label: "Success",     bg: "#dcfce7", color: "#166534" },
  blocked: { label: "Blocked",     bg: "#fee2e2", color: "#991b1b" },
  review:  { label: "Review Req.", bg: "#fef9c3", color: "#854d0e" },
};

const AVATAR_COLORS = [
  { bg: "#dce8ff", color: "#002045" },
  { bg: "#e0f2fe", color: "#0369a1" },
  { bg: "#f3e8ff", color: "#7e22ce" },
];

const TABLE_HEADERS = ["Timestamp", "Administrator", "Action Taken", "Entity Affected", "Status"];

const AuditLog = () => (
  <div
    style={{
      background: "white",
      borderRadius: 16,
      border: "1px solid #f0f4ff",
      boxShadow: "0 4px 20px -4px rgba(0,0,0,0.05)",
      overflow: "hidden",
    }}
  >
    {/* Header */}
    <div
      className="d-flex align-items-center justify-content-between"
      style={{ padding: "20px 24px", borderBottom: "1px solid #f0f4ff" }}
    >
      <div>
        <h5 className="fw-bold mb-0" style={{ color: "#002045" }}>User Audit Log</h5>
        <p className="text-muted small mb-0 mt-1">Real-time administrative event stream</p>
      </div>
      <div className="d-flex gap-2">
        <button className="btn btn-sm btn-outline-secondary fw-semibold" style={{ fontSize: "0.7rem" }}>
          Export CSV
        </button>
        <button className="btn btn-sm btn-link fw-semibold p-0" style={{ fontSize: "0.7rem", color: "#002045" }}>
          View All Logs
        </button>
      </div>
    </div>

    {/* Table */}
    <div className="table-responsive">
      <table className="table table-hover mb-0" style={{ fontSize: "0.85rem" }}>
        <thead style={{ background: "#f8fafc" }}>
          <tr>
            {TABLE_HEADERS.map((h) => (
              <th
                key={h}
                style={{
                  padding: "12px 24px",
                  fontSize: "0.6rem", fontWeight: 700,
                  textTransform: "uppercase", letterSpacing: "0.1em",
                  color: "#6b7280", borderBottom: "1px solid #f0f4ff",
                  whiteSpace: "nowrap",
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {AUDIT_LOG.map((row, i) => {
            const status = STATUS_CONFIG[row.status];
            const avatar = AVATAR_COLORS[i % AVATAR_COLORS.length];
            return (
              <tr key={i} style={{ borderLeft: row.status === "blocked" ? "3px solid #fca5a5" : "3px solid transparent" }}>
                <td style={{ padding: "14px 24px", color: "#94a3b8", fontWeight: 500, fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                  {row.timestamp}
                </td>
                <td style={{ padding: "14px 24px" }}>
                  <div className="d-flex align-items-center gap-2">
                    <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatar.bg, color: avatar.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.65rem", fontWeight: 700, flexShrink: 0 }}>
                      {row.initials}
                    </div>
                    <span className="fw-semibold" style={{ color: "#002045", fontSize: "0.85rem" }}>{row.name}</span>
                  </div>
                </td>
                <td style={{ padding: "14px 24px", color: "#374151" }}>{row.action}</td>
                <td style={{ padding: "14px 24px" }}>
                  <code style={{ background: "#f1f5f9", padding: "2px 8px", borderRadius: 4, fontSize: "0.72rem", color: "#64748b", fontWeight: 500 }}>
                    {row.entity}
                  </code>
                </td>
                <td style={{ padding: "14px 24px" }}>
                  <span style={{ padding: "3px 10px", borderRadius: 999, background: status.bg, color: status.color, fontSize: "0.6rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>
                    {status.label}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>

    {/* Footer */}
    <div className="text-center" style={{ padding: "14px 24px", background: "#f8fafc", borderTop: "1px solid #f0f4ff" }}>
      <button className="btn btn-link btn-sm fw-bold p-0" style={{ fontSize: "0.7rem", letterSpacing: "0.1em", textTransform: "uppercase", color: "#002045" }}>
        Load Older Entries
      </button>
    </div>
  </div>
);

export default AuditLog;
